/* global L */
import Map, { streetLayer } from '../../modules/Map'


const route = document.getElementById('routeDirections')
if (route !== null) {
    const from = route.getAttribute('data-from')
    const to = route.getAttribute('data-to')

    const map = new Map('map', {
        coords: [50.1016, -5.2750],
    }, {
        Streets: streetLayer('mapbox'),
    })

    map.map.invalidateSize()

    const mbDirections = L.mapbox.directions({ profile: 'mapbox.driving' })

    L.mapbox.directions.layer(mbDirections).addTo(map.map)
    L.mapbox.directions.routesControl('routes', mbDirections).addTo(map.map)
    L.mapbox.directions.instructionsControl('instructions', mbDirections).addTo(map.map)

    mbDirections.setOrigin(from)
    mbDirections.setDestination(to)

    mbDirections.on('load', (dir) => {
        // Loop through all route coordinates and determine bounds for route.
        let minLat = 90
        let minLng = 180
        let maxLat = -90
        let maxLng = -180

        dir.routes[0].geometry.coordinates.forEach((laCoordinate) => {
            const lat = laCoordinate[1]
            const lng = laCoordinate[0]
            if (lat < minLat) {
                minLat = lat
            }
            if (lng < minLng) {
                minLng = lng
            }
            if (lat > maxLat) {
                maxLat = lat
            }
            if (lng > maxLng) {
                maxLng = lng
            }
        })

        const directionsBounds = L.latLngBounds(L.latLng(minLat, minLng), L.latLng(maxLat, maxLng))

        map.map.fitBounds(directionsBounds)
        mbDirections.selectRoute(dir.routes[0])
    })

    mbDirections.query()
}
